import { configure } from "vee-validate";

// vee-validate's global behaviour, set by kit/form/useKitForm.ts when the first
// form loads, and by test/setup.ts so a spec validates the way the app does. Keeping a value
// through an unmount is a useForm option, not a global one, so KitForm sets it.
//
// validateOnBlur without validateOnModelUpdate: an error shows once the field is
// left or the form is submitted, never while the first character is typed.
// FieldRow turns keystroke checking on for a field once it shows an error.
export function configureForms() {
  configure({
    validateOnBlur: true,
    validateOnChange: true,
    validateOnInput: false,
    validateOnModelUpdate: false,
  });
}
